import { render, staticRenderFns } from "./BaseCC.vue?vue&type=template&id=3128be90&"
import script from "./BaseCC.vue?vue&type=script&lang=js&"
export * from "./BaseCC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports